import React from "react";
import "./Forms.scss";

export const FormTitle:React.FC = ({children}) => {
    return (
        <div className="form__title">
            {children}
        </div>
    )
}